import { useContext } from 'react';
import { ListingPickerContext } from '@/components/Provider/ListingPickerProvider';

export function useListingPicker() {
  return useContext(ListingPickerContext);
}
